import { render, staticRenderFns } from "./HomeBannerNews.vue?vue&type=template&id=6664b9b2&scoped=true"
import script from "./HomeBannerNews.vue?vue&type=script&lang=js"
export * from "./HomeBannerNews.vue?vue&type=script&lang=js"
import style0 from "./HomeBannerNews.vue?vue&type=style&index=0&id=6664b9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6664b9b2",
  null
  
)

export default component.exports